import React from 'react';
import { Box } from '@mui/material';

import { FormInput } from '@occc-app/Offer/components/FormInput';

import { ProductGroupSelectEnhancedContainer as ProductGroupSelect } from './ProductGroupSelectEnhanced/ProductGroupSelectEnhancedContainer';

import {
  greaterThanZeroValidation,
  numberValidation,
  requiredValidation,
  withFormEventValidation,
} from '../../validatableComponent';
import { ButtonGroup } from '../../ButtonGroup';
import { State } from '../redux';

const PurchaseThresholdFormInput = withFormEventValidation(
  FormInput,
  requiredValidation,
  numberValidation,
  greaterThanZeroValidation,
);

type ComponentState = State['emConfiguration']['productPurchase'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  editMode: boolean;
  fieldDisabled: (field: Fields) => boolean;
};

const ProductPurchaseConfiguration: React.FC<Props> = (props) => {
  const { countProductsBy, editMode, eligibleProductGroups, fieldDisabled, purchaseThreshold } =
    props;

  return (
    <Box>
      <Box my={4}>
        <PurchaseThresholdFormInput
          id='purchaseThreshold'
          label='Purchase Threshold'
          readonly={fieldDisabled('purchaseThreshold')}
          type='text'
          value={purchaseThreshold}
          required={true}
        />
      </Box>

      <Box mb={4}>
        <ButtonGroup
          label='Count Product By'
          name='countProductsBy'
          readonly={fieldDisabled('countProductsBy')}
          selectedValue={countProductsBy}
        >
          <ButtonGroup.Option value='quantity'>Quantity</ButtonGroup.Option>
          <ButtonGroup.Option value='money_amount'>Money Amount</ButtonGroup.Option>
        </ButtonGroup>
      </Box>

      <Box mb={4}>
        <ProductGroupSelect
          editMode={editMode}
          label='Included Product Groups'
          selectedProductGroups={eligibleProductGroups}
          onChange={() => {}}
          readonly={fieldDisabled('eligibleProductGroups')}
        />
      </Box>
    </Box>
  );
};

export { ProductPurchaseConfiguration };
